import { render } from "./WikipediaText.vue?vue&type=template&id=d535729e&scoped=true"
import script from "./WikipediaText.vue?vue&type=script&lang=js"
export * from "./WikipediaText.vue?vue&type=script&lang=js"

import "./WikipediaText.vue?vue&type=style&index=0&id=d535729e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d535729e"]])

export default __exports__